import { SvgIcon, SvgIconProps } from '@mui/material';

export function SortIcon(props?: SvgIconProps) {
	return (
		<SvgIcon
			width='14'
			height='18'
			viewBox='0 0 14 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path d='M7 18L0.937822 12L13.0622 12L7 18Z' />
			<path d='M7 1.22392e-06L13.0622 6L0.937821 6L7 1.22392e-06Z' />
		</SvgIcon>
	);
}
